import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { SelectionItemLoading } from '@pages/SelectionItem/model/types'
import type { TypeMappingSelectionOutput as MappedSelection } from '@shared/api/middleware/mappingAPI/selection/type'
import type { TypeMappingRestOutput as MappedRestaurant } from '@shared/api/middleware/mappingAPI/restaurant/type'
import type { PropsSelectionRestaurants } from '@shared/api/types/apiPublicParameters'
import type { TypeMappingPaginationOutput as MappedPagination } from '@shared/api/middleware/mappingAPI/pagination/type'
import { selectionItemInitialState } from '@pages/SelectionItem/model/initialState'

const selectionItem = createSlice({
  name: 'selectionItem',
  initialState: selectionItemInitialState,

  reducers: {
    setSelection(state, action: PayloadAction<MappedSelection>) {
      state.selection.data = action.payload
    },
    setSelectionList(state, action: PayloadAction<MappedRestaurant[] | null>) {
      state.selection.restaurants = action.payload
    },
    setParamsRequest(state, action: PayloadAction<PropsSelectionRestaurants | null>) {
      state.selection.paramsRequest = action.payload
    },
    setPagination(state, action: PayloadAction<MappedPagination | null>) {
      state.selection.pagination = action.payload
    },
    setPaginationPage(state, action: PayloadAction<MappedPagination>) {
      if (state.selection.pagination) state.selection.pagination.page = action.payload.page
    },
    setLoading(state, action: PayloadAction<SelectionItemLoading>) {
      state.selection.loading = action.payload
    },
    setRecommendationList(state, action: PayloadAction<MappedRestaurant[] | null>) {
      state.recommended = action.payload?.length ? action.payload : null
    },
    setAfishaSelectedList(state, action: PayloadAction<MappedSelection[] | null>) {
      state.afishaSelected = action.payload?.length ? action.payload : null
    },
    resetState() {
      return selectionItemInitialState
    },
  },
})

export const {
  setSelection,
  setSelectionList,
  setParamsRequest,
  setPagination,
  setPaginationPage,
  setLoading,
  setRecommendationList,
  setAfishaSelectedList,
  resetState,
} = selectionItem.actions
export default selectionItem.reducer
